/* eslint-disable */
import { useEffect } from 'react'
import { Paper, Typography, Box, CircularProgress } from '@mui/material'
import { redirectToLogout } from '../../Auth'
import Cookies from 'js-cookie'
import logoutApi from '../../apiCalls/authApi'

export default function Logout() {
  useEffect(() => {
      logoutApi()
        .catch()
        .finally(() => {
          Cookies.remove('auth_token')
          localStorage.clear()
          sessionStorage.clear()
          redirectToLogout()
        })
  }, [])

  return (
    <Paper
      square
      elevation={0}
      sx={{
        height: '90vh',
        width: '90vw',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          maxWidth: 400,
          mx: 'auto'
        }}
      >
        <Typography variant='h5' sx={{ mb: 4 }}>
          Logging Out
        </Typography>

        <CircularProgress sx={{ mb: 3 }} />

        <Typography variant='h6' sx={{ mb: 2 }}>
          You are being logged out...
        </Typography>

        <Typography variant='body2' color='textSecondary'>
          Please wait while we securely log you out of the system.
        </Typography>
      </Box>
    </Paper>
  )
}
